// exact mapping to your backend codes
export function pathToPermissionCode(pathname = '') {
  const first = String(pathname).split('/').filter(Boolean)[0] || 'dashboard';

  // detail/alias routes that should inherit a parent permission
  const aliasMap = {
    'order-details': 'orders',
    'hardware-profile': 'hardware',
    'profile': 'users',

    // ONLY special case you have now: plural route, singular permission
    'ingredients': 'ingredient'
  };

  const key = aliasMap[first] || first;
  return `${key}:access`;
}

export function hasAccess(userPerms = [], path) {
  return userPerms.includes(pathToPermissionCode(path));
}
